<template>
    <v-container fluid class="main-container pa-4">
        <div class="widget-grid ga-4">
            <FlipCard v-for="widget in widgetData" :key="widget.title">

                <template #front="{ onClick }">
                    <v-card @click="onClick" :color="widget.color" class="h-100 pa-4 rounded-xl">
                        <span>{{ $t('widget.' + widget.title) }}</span>

                        <v-row class="widget-card-recto">
                            <span class="text-display-large">{{ widget.count }}</span>
                        </v-row>

                    </v-card>
                </template>

                <template #back="{ onClick }">
                    <v-card @click="onClick" :color="widget.color" elevation="12" class="widget-card-verso h-100">
                        <AgGrid class="fill-height" v-if="widget.type != 0" :fetchData="widget.data" :columnDefs="widgetColumnDefs" :row-selection="rowSelection" />
                    </v-card>
                </template>
            </FlipCard>
        </div>
    </v-container>
</template>

<script setup>
    import AgGrid from '@/components/AgGrid.vue';
    import FlipCard from '@/components/FlipCard.vue';
    import { inject, nextTick, onMounted, ref } from 'vue';
    import { toast } from 'vue3-toastify';
    import { useLogStore } from '@/stores/logStore';
    import { useUserStore } from '@/stores/userStore';

    const urlWebAPI = inject('urlWebAPI');
    const translate = inject('translate');
    const getFormBody = inject('getFormBody');
    const logStore = useLogStore();
    const userStore = useUserStore();

    const domLayout = 'autoHeight';
    const rowSelection = {
        mode: 'singleRow',
        enableClickSelection: true,
        checkboxes: false,
    };
    const widgetData = ref([]);
    const widgetColors = ['#0e5183', '#0f568c', '#0f5c95', '#10619e', '#1167a7', '#126cb1', '#1472ba'];
    const widgetColumnDefs = [
        {
            field: 'customer',
            headerName: translate('customer', 'column'),
            filter: false,
            menuTabs: [],
        },
        {
            field: 'value',
            headerName: translate('count', 'column'),
            sort: 'desc',
            filter: false,
            menuTabs: [],
        },
    ];
    onMounted(() => {
        //nexttick to delay grid rendering, so that the page's fade in effect have time to be displayed
        nextTick(() => {
            getWidgetData();
        });
    });
    


    function getWidgetData() {
        const data = {
            token: userStore.getUser().token,
            distributorId: userStore.getUser().distributorId,
        };

        var formBody = getFormBody(data);

        fetch(urlWebAPI + 'GetWidgetData', {
            method: 'POST',
            body: formBody,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
            .then(result => result.json())
            .then(data => {
                widgetData.value = data.map(widget => ({
                    ...widget,
                    color: widgetColors[Math.floor(Math.random() * widgetColors.length)],
                }));
            })
            .catch(error => {
                logStore.log(error, 'error');
                toast.error('Error during executing widget data.');
            });
    }
</script>

<style scoped>


    .widget-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        grid-template-rows: repeat(3, minmax(0, 1fr));
        width: 100%;
        height: 100%;
    }

    .widget-grid :deep(.flip-container),
    .widget-grid :deep(.flipper),
    .widget-grid :deep(.front),
    .widget-grid :deep(.back) {
        height: 100%;
    }

    .widget-card-verso {
        box-sizing: border-box;
    }

    .widget-card-verso :deep(.AgGrid) {
        height: 100%;
        flex: 1 1 auto;
    }

    .widget-card-verso :deep(.AgGrid) > :first-child {
        height: 100% !important;
    }
</style>
